export default __webpack_public_path__ + "static/media/CV_Brigitta_Toth_2023.b432f8f9.pdf";